<template>
    <v-content>
        <v-row>
            <v-col md="4">
                <v-select v-model="fiscalYearID" dense outlined
                          :items="fiscalYearList"
                          item-text="id"
                          @change="loadItems"
                          item-value="value">
                    <template v-slot:label>
                        {{ $t("fiscal_year") }}
                    </template>
                </v-select>
            </v-col>
            <v-col md="4" v-if="fiscalYearID">
                <v-btn color="primary ml-4" @click="sendRequest">{{$t('request')}}</v-btn>
            </v-col>
        </v-row>
        <vue-good-table mode="remote"
                        @on-page-change="onPageChange"
                        @on-sort-change="onSortChange"
                        @on-column-filter="onColumnFilter"
                        @on-per-page-change="onPerPageChange"
                        :totalRows="totalRecords"
                        :isLoading.sync="isLoading"
                        :pagination-options="{ enabled: true, }"
                        :rows="rows"
                        :columns="columns">
            <template slot="table-column" slot-scope="props">
                <span>
                    {{ $t(props.column.label) }}
                </span>
            </template>

        </vue-good-table>

    </v-content>
</template>

<script>
    import axios from "axios";
    import store from "@/store";
    import { mapGetters } from "vuex";

    export default {
        name: 'log',
        watch: {},
        components: {
        },
        computed: {
            ...mapGetters({
                userRole: 'getUserRole',
                usersData: 'getUserData',
            }),
        },
        data() {
            return {
                success: false,
                popout: true,
                fiscalYearList: [],
                fiscalYearID: 0,
                reportID: 0,
                isLoading: false,
                dialogRow: false,
                permissionData: {},
                columns: [
                    {
                        label: "fiscal_year",
                        field: "fiscalYearName"
                    },
                    {
                        label: "amount",
                        field: "amount"
                    },
                ],
                firstrows: [],
                rows: [],
                totalRecords: 0,
                isLoadedFromServer: false,
                logData: {
                    reportID: 0,
                },
                userData: {
                    totalRows: 0,
                    editItemIndex: null,
                    deleteFormData: {}
                },
                serverParams: {
                    branchID: 0,
                    companyID: 0,
                    departmentID: 0,
                    depoID: 0,
                    fiscalYearID: 0,
                    statusID: 0,
                    transferModeID: 0,
                    search: "",
                    columnFilters: {},
                    sort: [
                        {
                            field: "FiscalYearID",
                            type: "desc"
                        }
                    ],
                    page: 1,
                    perPage: 10
                },
                IsActive: false,
                headers: [],
                titleHeaders: [],
                helpData: [],
                listDDLData: [],
                role: "",
                user: {},
                tableView: false,
                table: false,
            };
        },
        mounted() {
            this.getMenu(),
            this.apiData()
        },
        created() {
            this.currentFiscalYear()
        },
        methods: {
            onResponse(data) {
                console.log("yets" + data);
                if (data == true) {
                    this.dialogCreate = false;
                    this.dialogEdit = false;
                    this.dialogRow = false;
                    this.apiData();
                }
            },
            onFormResponse() {
                this.dialogRow = false;
                this.loadItems();
            },
            scrollToTargetDiv() {
                if (this.$refs.targetDiv) {
                    this.$refs.targetDiv.scrollIntoView({ behavior: 'smooth', block: 'start' });
                }
            },
            searchInput() {
                this.apiData();
                this.loadItems();
            },

            updateParams(newProps) {
                this.serverParams = Object.assign({}, this.serverParams, newProps);
            },


            onPageChange(params) {
                this.updateParams({ page: params.currentPage });
                this.apiData();
                this.loadItems();
            },

            onPerPageChange(params) {
                this.updateParams({ perPage: params.currentPerPage });
                this.apiData();
                this.loadItems();
            },

            onSortChange(params) {
                this.updateParams({
                    sort: [
                        {
                            type: params[0].type,
                            field: params[0].field
                        }
                    ]
                });
                this.apiData();
                this.loadItems();
            },

            onColumnFilter(params) {
                this.updateParams(params);
                this.apiData();
                this.loadItems();
            },
            sendRequest() {
                this.dialogRow = true
                this.logData = {
                    yearID: this.fiscalYearID
                }
                this.$nextTick(() => {
                    this.$refs.requestComponent.loadData();
                });
            },
            apiData() {
                axios.get("ReportSettings/GetReportYearList").then(response => {
                    this.fiscalYearList = response.data
                    this.yearList = response.data
                })
            },
            currentFiscalYear() {
                axios.get("ReportSettings/GetCurrentFiscalYear").then(response => {
                    this.fiscalYearID = response.data.value
                    this.loadItems()
                })
            },
            async loadItems() {
                let param = {
                    PageSize: this.serverParams.perPage == -1 ? this.userData.totalRecords : this.serverParams.perPage,
                    PageNo: this.serverParams.page,
                    OrderType: this.serverParams.sort[0].type,
                    OrderBy: this.serverParams.sort[0].field,
                    branchID: this.serverParams.branchID,
                    companyID: this.serverParams.companyID,
                    depoID: this.serverParams.depoID,
                    fiscalYearID: parseInt(this.fiscalYearID),
                };
                axios.post('ReportSettings/GetBudgetAndExpensesReportAsync', param).then(response => {
                    this.rows = response.data
                    this.userData.totalRecords = response.data.totalCount
                }).catch(res => {
                    console.log(res)
                })

            },
            nullTitle( title ) {
                return title == null
            },
            getMenu() {
                let userData = JSON.parse(store.getters.getInfo);

                this.user.name = userData.userName;
                this.role = userData.role;


            },
        }
    };
</script>

<style lang="scss" scoped>

    .v-sheet--offset {
        top: -24px;
        position: relative;
    }

    .tbl th {
        padding-top: 12px;
        padding-bottom: 12px;
        text-align: left;
        background-color: $main-color;
        color: white;
    }

    table, td, th {
        border: 1px solid #ddd;
        text-align: left;
    }

    table {
        border-collapse: collapse;
        width: 100%;
    }

    th, td {
        padding: 15px;
    }
</style>


